import { SET_PAYROLL_DATA, SET_PAYROLL_ID, SET_PAYROLL_OPTIONS } from "constants/payrollConstants";

export const setPayrollData = (payroll) => {
  return {
    type: SET_PAYROLL_DATA,
    payroll,
  };
};
export const setPayrollOptionsGlobal = (options) => {
  return {
    type: SET_PAYROLL_OPTIONS,
    options,
  };
};
export const setPayrollId = (id) => {
  return {
    type: SET_PAYROLL_ID,
    id,
  };
};
